"use client";

import { Button } from "@/components/ui/button";

interface MobileBottomBarProps {
  priceLabel: string;
  amount: number;
  buttonText: string;
  disabled?: boolean;
  onClick: () => void;
  visible: boolean;
}

/**
 * Fixed mobile bottom bar — shown when the sidebar scrolls out of view.
 * Used in CartContent and CheckoutContent.
 */
export function MobileBottomBar({
  priceLabel,
  amount,
  buttonText,
  disabled = false,
  onClick,
  visible,
}: MobileBottomBarProps) {
  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 bg-white border-t border-neutral-200 px-4 py-3 sm:hidden">
      <div className="flex items-center justify-between gap-4">
        <div className="min-w-0">
          <p className="text-xs text-neutral-400">{priceLabel}</p>
          <p className="text-base font-semibold">{amount.toLocaleString()}원</p>
        </div>
        <Button
          className="h-11 px-6 bg-neutral-900 text-white text-sm font-medium shrink-0 hover:bg-neutral-800"
          disabled={disabled}
          onClick={onClick}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
}
